/**
 * types redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    LOAD_TYPE_DEFINITIONS
} from "./consts";


export const loadTypeDefinitionsSuccessAction = (definitions) => ({
    type: LOAD_TYPE_DEFINITIONS,
    definitions: definitions
});
